import React, { useState, useEffect } from "react";
import axios from "axios";
import { menuCategories as mockMenu } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import SectionBg from "./SectionBg";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Menu() {
  const { t, lang } = useLang();
  const [categories, setCategories] = useState(mockMenu);
  const [active, setActive] = useState(mockMenu[0].id);

  useEffect(() => {
    axios.get(`${API}/menu`)
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length) {
          setCategories(res.data);
          setActive(res.data[0].id);
        }
      })
      .catch(() => {});
  }, []);

  const current = categories.find((c) => c.id === active) || categories[0];
  const labelOf = (c) => (lang === "en" && c.label_en ? c.label_en : c.label);
  const nameOf = (i) => (lang === "en" && i.name_en ? i.name_en : i.name);
  const descOf = (i) => (lang === "en" && i.desc_en ? i.desc_en : i.desc);

  return (
    <section id="menu" className="relative py-24 md:py-32 bg-[#FBF7F0] overflow-hidden">
      <SectionBg section="menu" />
      <div className="relative z-10 max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14 reveal">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#C9A24B]" />
            <span className="text-[#B0863B] tracking-[0.3em] text-xs uppercase">{t("menu.badge")}</span>
            <span className="h-px w-12 bg-[#C9A24B]" />
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#23201C] leading-tight">
            {t("menu.title1")} <span className="italic text-[#C9A24B]">{t("menu.highlight")}</span>
          </h2>
          <p className="text-[#8a7f6b] mt-4 text-sm">{t("menu.note")}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-12 reveal">
          {categories.map((c) => (
            <button key={c.id} onClick={() => setActive(c.id)}
              className={`px-6 py-2.5 rounded-full text-sm font-medium tracking-wide transition-all duration-300 ${
                active === c.id
                  ? "bg-[#1C1815] text-[#C9A24B] shadow-lg"
                  : "bg-white text-[#5a5347] hover:bg-[#f1e9da] border border-[#eae0cd]"
              }`}>
              {labelOf(c)}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-x-12 gap-y-1">
          {current?.items.map((item) => (
            <div key={item.id || item.name} className="group py-5 border-b border-[#e7ddc9] flex items-start gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="font-display text-xl text-[#23201C] group-hover:text-[#B0863B] transition-colors">{nameOf(item)}</h3>
                  {item.tag && (
                    <span className="text-[10px] uppercase tracking-wider bg-[#C9A24B]/15 text-[#B0863B] px-2 py-0.5 rounded-full">{item.tag}</span>
                  )}
                </div>
                <p className="text-[#7c7264] text-sm leading-relaxed pr-4">{descOf(item)}</p>
              </div>
              <div className="font-display text-xl text-[#C9A24B] whitespace-nowrap pt-0.5">€ {item.price}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}